export default __webpack_public_path__ + "static/media/phivolcs_seal.0746e8f4.png";